export default "__VITE_ASSET__7oZx2Z31__"